<template>
    <div class="fund-list">
        <el-row v-if="fundInfo.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad && pageHasLoad"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="270" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        <span class="fund-name-text">{{ scope.row.fundname }}</span>
                        <!-- 快赎判断 -->
                        <span v-if="scope.row.allowfastredeemflag === '1'" class="fund-name-icon">
                            快
                        </span>
                    </div>
                    <div>
                        {{ scope.row.fundcode }}
                        <!-- FOF-7 -->
                        <span
                            v-if="
                                scope.row.fundshowtype === '7' &&
                                scope.row.cycleratevalue &&
                                scope.row.cycleratetype
                            "
                        >
                            | 封闭期{{
                                scope.row.cycleratevalue +
                                $cache.getDict("220027", scope.row.cycleratetype)
                            }}
                        </span>
                        <div v-if="$util.hasFM(scope.row)" class="fm1">浮动管理费基金</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '单位净值/万份收益'
                        : tabIndex != '5'
                        ? '单位净值'
                        : '每万份收益'
                "
                align="center"
                width="120"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.fundshowtype != '5'">
                        <div>
                            {{ $util.fmtNum(scope.row.nav, 4) }}
                        </div>
                        <div v-if="scope.row.nav" style="color: var(--color-text-accent)">
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            {{ $util.fmtNum(scope.row.fundincomeunit, 4) }}
                        </div>
                        <div
                            v-if="scope.row.fundincomeunit"
                            style="color: var(--color-text-accent)"
                        >
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="tabIndex != '5'" label="累计净值" align="center">
                    <template slot-scope="scope">
                        <div>{{ $util.fmtNum(scope.row.totalnav, 4) }}</div>
                    </template>
                </el-table-column> -->
            <el-table-column
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '日涨跌幅/7日年化'
                        : tabIndex != '5'
                        ? '日涨跌幅'
                        : '7日年化收益'
                "
                align="center"
                width="100"
            >
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.fundshowtype != '5'"
                        :class="
                            scope.row.dayfloatprofit > 0
                                ? 'add'
                                : scope.row.dayfloatprofit < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.dayfloatprofit) }}
                    </span>
                    <span
                        v-else
                        :class="
                            scope.row.growthrate > 0
                                ? 'add'
                                : scope.row.growthrate < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.growthrate) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近六月" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.month6ud > 0 ? 'add' : scope.row.month6ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.month6ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近一年" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.year1ud > 0 ? 'add' : scope.row.year1ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.year1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="今年以来" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.thisyear1ud > 0
                                ? 'add'
                                : scope.row.thisyear1ud < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.thisyear1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近三年" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.year3ud > 0 ? 'add' : scope.row.year3ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.year3ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="风险等级" align="center" min-width="120">
                <template slot-scope="scope">
                    <span style="white-space: nowrap">
                        {{ $cache.getDict("110143", scope.row.risklevel) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="$util.getConfig().hideFunc"
                label="操作"
                align="center"
                width="180"
            >
                <template slot-scope="scope">
                    <div class="btns">
                        <template
                            v-if="url !== 'glist' && xjbFundInfo.fundcode !== scope.row.fundcode"
                        >
                            <el-tooltip
                                v-if="scope.row.isBuy"
                                class="item"
                                effect="info"
                                :content="
                                    scope.row.isBuy +
                                    '，不能' +
                                    (scope.row.status == '1' ? '认购' : '申购')
                                "
                                placement="top"
                            >
                                <el-button disabled type="text" size="small">
                                    {{ scope.row.status == "1" ? "认购" : "申购" }}
                                </el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="callbackFn('20,22', scope.row)"
                            >
                                {{ scope.row.status == "1" ? "认购" : "申购" }}
                            </el-button>
                        </template>
                        <template v-if="xjbFundInfo.fundcode !== scope.row.fundcode && checkValid">
                            <div class="line"></div>
                            <el-tooltip
                                v-if="
                                    scope.row.fundclass != '1' &&
                                    scope.row.isCurrency &&
                                    xjbFundInfo.fundcode !== scope.row.fundcode
                                "
                                class="item"
                                effect="info"
                                :content="scope.row.isCurrency + '，不能定投'"
                                placement="top"
                            >
                                <el-button type="text" disabled size="small">定投</el-button>
                            </el-tooltip>
                            <el-button
                                v-if="
                                    scope.row.fundclass != '1' &&
                                    !scope.row.isCurrency &&
                                    xjbFundInfo.fundcode !== scope.row.fundcode
                                "
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="callbackFn('59', scope.row)"
                            >
                                定投
                            </el-button>
                        </template>

                        <template v-if="url !== 'glist' && $util.checkModuleid(100001003)">
                            <div
                                v-if="xjbFundInfo.fundcode !== scope.row.fundcode"
                                class="line"
                            ></div>
                            <el-button
                                v-if="scope.row.collection == '0'"
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="collectFund(scope.row)"
                            >
                                加自选
                            </el-button>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="unCollectFund(scope.row)"
                            >
                                取消自选
                            </el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>

<script>
import fundApi from "@/api/fund";

export default {
    name: "FundList",
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        hasLoad: {
            type: Boolean,
            default: false
        },
        tabIndex: {
            type: String,
            default: "0"
        },
        page: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            url: "", // 当前页面路由命名
            fundAll: [],
            curPage: 1,
            pageHasLoad: true,
            xjbFundInfo: {},
            checkValid: true // “基金定投”菜单是否放开
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund("fundInfo");
        },
        tabIndex() {
            this.getNewFund("tabIndex");
        },
        // allPage() {
        //     this.curPage = 1;
        // },
        page(val) {
            this.curPage = val;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.url = this.$route.name;
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};

        const menuModule =
            (this.$cache.getParamValue("menu_module") &&
                this.$cache.getParamValue("menu_module").menus) ||
            [];
        const getValidMenuIds = (menuModule) => {
            const ids = new Set();
            const traverse = (items) => {
                items.forEach((item) => {
                    ids.add(item.menuid);
                    if (item.menu) traverse(item.menu);
                });
            };
            traverse(menuModule);
            return Array.from(ids);
        };
        const validMenuIds = getValidMenuIds(menuModule);
        // 104-基金定投菜单，检查是否放开
        if (validMenuIds.length > 0 && !validMenuIds.includes(104)) {
            this.checkValid = false;
        }
    },
    methods: {
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        // 关注基金
        async collectFund(item) {
            const res = await fundApi.collectFund({
                fundcode: item.fundcode
            });
            // if (!res.error) {
            //     this.$set(this.fundAll[item.index], "collection", "1");
            // }
            this.$emit("new-fund", "1");
        },
        // 取消关注基金
        async unCollectFund(item) {
            const res = await fundApi.unCollectFund({
                fundcode: item.fundcode
            });
            // if (!res.error) {
            //     this.$set(this.fundAll[item.index], "collection", "0");
            // }
            this.$emit("new-fund", "1");
        },
        callbackFn(way, fund) {
            let moduleId = "";
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund);
            });
        },
        getNewFund(val) {
            this.pageHasLoad = false;
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index;
                _x.isBuy = this.$util.checkBuy(_x);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
            if (val == "fundInfo") {
                this.pageHasLoad = true;
            }
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (rate === "" || rate === null) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.fund-list {
    padding-bottom: 0;
    .el-table td.el-table__cell div {
        color: var(--color-text-primary);
    }
    .el-table td.el-table__cell span {
        color: var(--color-text-primary);
        &.add {
            color: var(--color-up);
        }
        &.reduce {
            color: var(--color-down);
        }
    }
    .el-table--fit {
        margin-bottom: 20px;
    }
    .fund-name {
        display: flex;
        align-items: center;

        .fund-name-text {
            cursor: pointer;
            max-width: calc(100% - 30px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .fund-name-icon {
            display: inline-block;
            background: var(--button-bg-press);
            font-size: 12px;
            color: var(--color-text-white) !important;
            border-radius: 50%;
            width: 24px;
            text-align: center;
            margin-left: 6px;
        }
    }
    .collection-name {
        font-weight: 400;
        font-size: 14px;
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: var(--color-divided);
        width: 1px;
        height: 12px;
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus,
    .el-button.is-disabled.is-plain {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
    }
    .el-button--text.is-disabled {
        color: var(--color-text-weak);
    }
    .el-table {
        border: 1px solid var(--color-divided);
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }
}
</style>
